import ReactDOM from "react-dom";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { EClientData } from "dto/IClient";
import CloseIcon from "assets/icons/close.svg?react";
import CopyIcon from "assets/icons/copye.svg?react";

import StarIcon from "assets/icons/star.svg?react";
import { formatToFormat } from "utils/formatToFormat";
import { Tooltip } from "@mui/material";

const PhoneClientModal: FC<Props> = ({ client, refWrapper }) => {
  if (!refWrapper?.current) return <></>;

  const position = refWrapper.current.getBoundingClientRect();

  const phones = client.Data.filter((d) => d.Type === EClientData.PHONE);

  return ReactDOM.createPortal(
    <div
      style={{
        left: `${position.left}px`,
        top: `${position.top + 32}px`,
      }}
      className={styles.wrapper}
    >
      <div className={styles.title}>
        Telefon
        <CloseIcon className={styles.icon} />
      </div>
      {phones.map((p) => (
        <div className={styles.box}>
          <div className={styles.name}>
            {formatToFormat(p.Value, "### ### ###")}
          </div>
          <div className={styles.options}>
            <Tooltip title="Kopiuj">
              <div>
                <CopyIcon
                  className={`${styles.icon} ${styles.copy}`}
                  onClick={() => {
                    navigator.clipboard.writeText(e.Value ?? "");
                  }}
                />
              </div>
            </Tooltip>
            {p.IsMain && <StarIcon className={styles.icone} />}
          </div>
        </div>
      ))}
    </div>,
    document.body
  );
};

export default PhoneClientModal;
